import { QueryClient } from 'react-query';
import { queryKeys } from '../hooks/queryKeyFactory';

export const invalidateDashboardQueries = (queryClient: QueryClient, watchListId: string): void => {
  queryClient.invalidateQueries([queryKeys.fetchRiskProducts.dashboard.byWatchList(watchListId)]);
};
